import { BoxStyleProps } from "@twilio-paste/core/box";
import { TextStyleProps } from "@twilio-paste/core/text";

/*
 * CSAT card (v2). Cores idiomáticas via tokens do Paste; a cor da marca (primaryColor, config) entra
 * como inline style no CsatCard (Paste não aceita hex cru — ver lessons.md). Mira em data-test/role,
 * nunca em classe hash do Emotion.
 */
export const containerStyles: BoxStyleProps = {
    padding: "space60",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    borderTopWidth: "borderWidth10",
    borderTopStyle: "solid",
    borderTopColor: "colorBorderWeaker"
};

export const titleStyles: TextStyleProps = {
    fontSize: "fontSize40",
    fontWeight: "fontWeightSemibold",
    marginBottom: "space50"
};

export const scaleGroupStyles: BoxStyleProps = {
    display: "flex",
    columnGap: "space30",
    justifyContent: "center",
    marginBottom: "space50",
    flexWrap: "wrap"
};

export const optionStyles: BoxStyleProps = {
    cursor: "pointer",
    backgroundColor: "colorBackgroundBody",
    borderWidth: "borderWidth20",
    borderStyle: "solid",
    borderColor: "colorBorderWeaker",
    borderRadius: "borderRadius20",
    padding: "space30",
    minWidth: "sizeSquare80",
    fontSize: "fontSize40",
    lineHeight: "lineHeight40"
};

export const hintStyles: TextStyleProps = {
    fontSize: "fontSize20",
    color: "colorTextWeak",
    marginTop: "space20",
    marginBottom: "space40"
};

export const commentWrapperStyles: BoxStyleProps = {
    width: "100%",
    marginBottom: "space20",
    textAlign: "left"
};

/*
 * A variante do atendimento. Mesmo card, outra economia de espaço: aqui ele divide uma janela de
 * 380x600 com uma conversa em andamento, então a moldura vira uma faixa presa acima do composer em
 * vez de um bloco centralizado que empurra a conversa para cima.
 *
 * A borda muda de lado (de topo para topo E base) porque a faixa passa a ter conversa acima dela e
 * campo de digitação abaixo — sem a borda de baixo ela encosta no composer e os dois viram um bloco só.
 */
export const containerAtendimentoStyles: BoxStyleProps = {
    paddingTop: "space40",
    paddingBottom: "space40",
    paddingLeft: "space50",
    paddingRight: "space50",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "colorBackgroundRowStriped",
    borderTopWidth: "borderWidth10",
    borderTopStyle: "solid",
    borderTopColor: "colorBorderWeaker",
    borderBottomWidth: "borderWidth10",
    borderBottomStyle: "solid",
    borderBottomColor: "colorBorderWeaker"
};

/* Título e dispensar na MESMA linha: colapsado, o card inteiro cabe em duas (título+X, e a escala). */
export const cabecalhoAtendimentoStyles: BoxStyleProps = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "space30"
};

export const tituloAtendimentoStyles: TextStyleProps = {
    fontSize: "fontSize20",
    fontWeight: "fontWeightSemibold",
    color: "colorTextWeak"
};

/*
 * A escala CENTRALIZADA na faixa. A primeira versão alinhava à esquerda, encostada no título, e ficou
 * desequilibrada: cinco glifos ocupam pouco mais de um terço dos 380px, e o resto da linha virava um
 * vazio à direita que puxava o olho para o lugar errado. Centralizada, a escala vira o alvo da faixa —
 * que é o que ela é: o único gesto que se pede ali.
 */
export const escalaAtendimentoStyles: BoxStyleProps = {
    display: "flex",
    columnGap: "space20",
    justifyContent: "center",
    marginTop: "space20",
    flexWrap: "wrap"
};
